module.exports = __webpack_public_path__ + "static/img/jinan.9550899.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jinan.jpg
// module id = pL4f
// module chunks = 0